// Submission helper: posts to our backend (saves in DB for admin panel)
// and also forwards to FormSubmit so the inbox receives the email.

import { enquiries } from './api';

const RECIPIENT = 'info.essbeeheaters@gmail.com';
const FORMSUBMIT_URL = `https://formsubmit.co/ajax/${RECIPIENT}`;

export async function sendEnquiry(payload, formType = 'Enquiry') {
  let backendOk = false;
  let emailOk = false;

  // 1. Save to backend (for admin dashboard)
  try {
    await enquiries.submit({
      name: payload.name || '',
      phone: payload.phone || '',
      email: payload.email || undefined,
      subject: payload.subject || undefined,
      message: payload.message || undefined,
      source: formType,
    });
    backendOk = true;
  } catch (e) {
    // fall through
  }

  // 2. Forward to email (so business receives notification)
  try {
    const body = {
      _subject: `New ${formType} from Ess Bee Heaters Website`,
      _template: 'table',
      _captcha: 'false',
      Source: formType,
      SubmittedAt: new Date().toLocaleString('en-IN'),
      ...payload,
    };
    const res = await fetch(FORMSUBMIT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    emailOk = res.ok;
  } catch (e) {
    // ignore
  }

  // 3. localStorage backup
  try {
    const stored = JSON.parse(localStorage.getItem('essbee_enquiries') || '[]');
    stored.push({ ...payload, formType, ts: new Date().toISOString() });
    localStorage.setItem('essbee_enquiries', JSON.stringify(stored));
  } catch (e) {
    // ignore
  }

  return backendOk || emailOk;
}
